import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CREDITNOTESDETAILS_INIT_ACTION,
  FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION,
  FETCH_CREDITNOTESDETAILS_FAIL_ACTION,
  FETCH_CREDITNOTESSEARCH_INIT_ACTION,
  FETCH_CREDITNOTESSEARCH_SUCCESS_ACTION,
  FETCH_CREDITNOTESSEARCH_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

function* fetchCreditNotes(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;
  try {
    const res = yield fetch(
      `${appConfig.ip}/creditNotes?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CREDITNOTESDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchSearchCreditNotes(value) {
  let searchVal = value.value.CreditNote;
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/creditNotes?limit=10&page=` +
        value.value.Spage +
        "&search=" +
        searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CREDITNOTESSEARCH_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CREDITNOTESSEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* CreditNotesActionWatcher() {
  yield takeEvery(FETCH_CREDITNOTESDETAILS_INIT_ACTION, fetchCreditNotes);
  yield takeEvery(FETCH_CREDITNOTESSEARCH_INIT_ACTION, fetchSearchCreditNotes);
}
